"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_1 = require("../../query/query");
var EntityArgs_1 = require("./EntityArgs");
var Entity = function (params) {
    var args = EntityArgs_1.default.parseArgs(params);
    return function (cls) {
        cls.prototype[query_1.QUERY] = __assign({}, cls.prototype[query_1.QUERY], args);
        return cls;
    };
};
exports.default = Entity;
//# sourceMappingURL=Entity.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/decorators/entity/Entity.js
// module id = 1446
// module chunks = 0